import React from 'react';
import { Property } from '../../types';
import { MapPin, Users, DollarSign, MoreVertical } from 'lucide-react';
import { formatCurrency, getStatusColor } from '../../utils/calculations';
interface PropertyCardProps {
  property: Property;
}
export function PropertyCard({
  property
}: PropertyCardProps) {
  return <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow" data-id="element-1269">
      <div className="flex justify-between items-start mb-4" data-id="element-1270">
        <div data-id="element-1271">
          <h3 className="text-lg font-semibold text-gray-900 line-clamp-1" data-id="element-1272">
            {property.name}
          </h3>
          <div className="flex items-center mt-1 text-sm text-gray-500" data-id="element-1273">
            <MapPin className="h-3.5 w-3.5 mr-1" data-id="element-1274" />
            {property.city}, {property.state}
          </div>
        </div>
        <button className="text-gray-400 hover:text-gray-600" data-id="element-1275">
          <MoreVertical className="h-5 w-5" data-id="element-1276" />
        </button>
      </div>

      <div className="flex items-center justify-between mb-6" data-id="element-1277">
        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusColor(property.status)}`} data-id="element-1278">
          {property.status}
        </span>
        <span className="text-lg font-bold text-gray-900" data-id="element-1279">
          {formatCurrency(property.rentAmount)}
          <span className="text-xs font-normal text-gray-500 ml-1" data-id="element-1280">/mo</span>
        </span>
      </div>

      <div className="border-t border-gray-100 pt-4 flex justify-between items-center text-sm" data-id="element-1281">
        <div className="flex items-center text-gray-600" data-id="element-1282">
          <Users className="h-4 w-4 mr-2 text-gray-400" data-id="element-1283" />
          {property.status === 'occupied' ? '1 Tenant' : 'No Tenants'}
        </div>
        <button className="text-blue-600 hover:text-blue-700 font-medium text-sm" data-id="element-1284">
          Manage
        </button>
      </div>
    </div>;
}